var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DataTableCRUD',{attrs:{"table":_vm.table,"options":_vm.options,"value":_vm.getFixedAssets},on:{"updateItem":function($event){return _vm.insertFixedAsset($event)},"newItem":function($event){return _vm.insertFixedAsset($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }